import * as React from 'react'
import styled, { css } from 'styled-components'
import { Screen } from '../commons'

interface CategoryTitleProps {
  icon: string
  name: string
}

const Title = styled.span`
  position: relative;
  z-index: 10;
  display: inline-block;

  font-family: var(--bs-font-family-sans-serif);
  font-weight: 700;
  text-transform: uppercase;

  &::before {
    content: '';
    display: block;

    position: absolute;
    left: -2px;
    bottom: 0;
    z-index: -1;

    height: 0.6em;
    width: calc(100% + 1rem);
    background-color: var(--bs-primary);

    transform: translateY(33.333333%);

    ${Screen.Desktop(css`
      width: calc(100% + 2rem);
    `)}
  }
  ${Screen.smaller('md')(css`
    font-size: 2rem;
  `)}
`
const Icon = styled.i`
  color: var(--bs-secondary);
  font-size: 1.2em;
  margin-right: 1rem;
`

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: start;
  margin-bottom: -0.25rem;

  font-size: var(--bs-h2-font-size);
  line-height: 1;
  z-index: 10;
  ${Screen.Desktop(css`
    margin-left: calc(var(--bs-grid-gutter-width) * -1);
    ${Icon} {
      position: absolute;
      top: 0;
      right: 100%;
     }
    }
  `)}
  ${Screen.smaller('md')(css`
    margin-bottom: -1.25rem;
  `)}
`
export const CategoryTitle: React.VFC<CategoryTitleProps> = ({ name, icon }) => {
  return (
    <Wrapper>
      <Icon className={icon} />
      <Title>{name}</Title>
    </Wrapper>
  )
}
